// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-aboutMe {
  position: relative;
  margin: 0 !important;
  display: block;
  overflow: hidden;
  box-sizing: border-box; }

* {
  box-sizing: border-box; }

.module-title {
  position: relative;
  margin-bottom: 50px;
  font-weight: 300;
  color: #5b5963;
  font-family: 'Poppins', sans-serif; }

.side-image {
  display: block;
  text-align: center;
  margin: auto;
  padding: 0; }
  .side-image img {
    max-height: 100%;
    max-width: 100%;
    size: cover;
    padding: 0;
    box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);
    -moz-box-shadow: 0 1px 2px rgba(34, 25, 25, 0.4);
    -webkit-box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);
    padding: 10px 10px 0;
    background-color: white;
    box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4); }

.side-image-text {
  display: block;
  background: #fff;
  padding: 100px 60px 50px;
  font-family: 'Poppins', sns-serif; }

@media (min-width: 992px) {
  .col-md-6 {
    width: 50%; } }

@media (min-width: 992px) {
  .col-md-offset-6 {
    margin-left: 50%; } }

@media (min-width: 992px) {
  .col-md-6 {
    width: 50%; } }

@media (min-width: 992px) {
  .col-md-1,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9 {
    float: left; } }

.module-title {
  position: relative;
  margin-bottom: 50px;
  font-weight: 300;
  color: #5b5963;
  text-align: center;
  font-family: 'Poppins', sans-serif; }
  .module-title span {
    font-size: 100px;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: -40px;
    z-index: 0;
    opacity: 0.05;
    font-weight: 700;
    text-transform: uppercase; }

.iconboxleft {
  position: relative;
  margin: 0 50px 50px; }

.iconboxleft-icon {
  position: absolute;
  width: 55px;
  left: 0;
  top: 0;
  font-size: 32px;
  line-height: 1;
  color: #116466; }

.iconboxleft-text {
  padding-left: 55px; }

.iconboxleft-title {
  font-family: 'Poppins', sans-serif;
  margin: 0 0 15px;
  padding: 0;
  font-size: 30px !important; }

.module-header {
  font-family: 'Poppins', sans-serif;
  margin: 0 0 50px;
  text-align: center; }

.module-line {
  background: #666;
  width: 55px;
  height: 1px;
  margin: 30px auto; }

/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    width: 100%; } }
`, "",{"version":3,"sources":["webpack://./src/store/components/aboutMe/index.scss"],"names":[],"mappings":"AAEA;EACI,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB,EAAA;;AAK1B;EACI,sBAAsB,EAAA;;AAG1B;EACI,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kCAAkC,EAAA;;AAGtC;EACI,cAAc;EAEd,kBAAkB;EAClB,YAAY;EAMZ,UAAU,EAAA;EAVd;IAaQ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,UAAU;IACV,2CAA2C;IAC3C,gDAAgD;IAChD,mDAAmD;IACnD,oBAAoB;IACpB,uBAAuB;IACvB,2CAA2C,EAAA;;AAInD;EACI,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC,EAAA;;AAGrC;EACI;IACI,UAAU,EAAA,EACb;;AAEL;EACI;IACI,gBAAgB,EAAA,EACnB;;AAGL;EACI;IACI,UAAU,EAAA,EACb;;AAGL;EACI;;;;;;;;;;;;IAYI,WAAW,EAAA,EACd;;AAqBL;EACI,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kCAAkC,EAAA;EANtC;IASQ,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,yBAAyB,EAAA;;AAIjC;EACI,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,eAAe;EACf,cAAc;EACd,cAAc,EAAA;;AAGlB;EACI,kBAAkB,EAAA;;AAGtB;EACI,kCAAkC;EAClC,gBAAgB;EAChB,UAAU;EACV,0BAA0B,EAAA;;AAG9B;EACI,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iBAAiB,EAAA;;AAGrB,+IAAA;AACA;EACI;IACI,WAAW,EAAA,EACd","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');\n\n.container-aboutMe {\n    position: relative;\n    margin: 0 !important;\n    display: block;\n    overflow: hidden;\n    box-sizing: border-box;\n    // height: 1200px;\n    // height: 600px;]=\n}\n\n* {\n    box-sizing: border-box;\n}\n\n.module-title {\n    position: relative;\n    margin-bottom: 50px;\n    font-weight: 300;\n    color: #5b5963;\n    font-family: 'Poppins', sans-serif;\n}\n\n.side-image {\n    display: block;\n    // position: absolute;\n    text-align: center;\n    margin: auto;\n    // -webkit-background-size: cover;\n    // -moz-background-size: cover;\n    // -o-background-size: cover;\n    // background-size: cover;\n    // height: 100%;\n    padding: 0; // background: ;\n    // margin-top: 200px;\n    img {\n        max-height: 100%;\n        max-width: 100%;\n        size: cover;\n        padding: 0;\n        box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);\n        -moz-box-shadow: 0 1px 2px rgba(34, 25, 25, 0.4);\n        -webkit-box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);\n        padding: 10px 10px 0;\n        background-color: white;\n        box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);\n    }\n}\n\n.side-image-text {\n    display: block;\n    background: #fff;\n    padding: 100px 60px 50px;\n    font-family: 'Poppins', sns-serif;\n}\n\n@media (min-width: 992px) {\n    .col-md-6 {\n        width: 50%;\n    }\n}\n@media (min-width: 992px) {\n    .col-md-offset-6 {\n        margin-left: 50%;\n    }\n}\n\n@media (min-width: 992px) {\n    .col-md-6 {\n        width: 50%;\n    }\n}\n\n@media (min-width: 992px) {\n    .col-md-1,\n    .col-md-10,\n    .col-md-11,\n    .col-md-12,\n    .col-md-2,\n    .col-md-3,\n    .col-md-4,\n    .col-md-5,\n    .col-md-6,\n    .col-md-7,\n    .col-md-8,\n    .col-md-9 {\n        float: left;\n    }\n}\n// #left {\n//     background-color: blue scroll center no-repeat;\n//     background-size: cover;\n//     height: 100%;\n//     position: absolute;\n// }\n\n// .column {\n//     float: left;\n//     width: 50%;\n// }\n\n// /* Clear floats after the columns */\n// .row:after {\n//     content: '';\n//     display: table;\n//     clear: both;\n//     height: 20%;\n// }\n.module-title {\n    position: relative;\n    margin-bottom: 50px;\n    font-weight: 300;\n    color: #5b5963;\n    text-align: center;\n    font-family: 'Poppins', sans-serif;\n\n    span {\n        font-size: 100px;\n        position: absolute;\n        left: 0;\n        right: 0;\n        text-align: center;\n        top: -40px;\n        z-index: 0;\n        opacity: 0.05;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n}\n\n.iconboxleft {\n    position: relative;\n    margin: 0 50px 50px;\n}\n\n.iconboxleft-icon {\n    position: absolute;\n    width: 55px;\n    left: 0;\n    top: 0;\n    font-size: 32px;\n    line-height: 1;\n    color: #116466;\n}\n\n.iconboxleft-text {\n    padding-left: 55px;\n}\n\n.iconboxleft-title {\n    font-family: 'Poppins', sans-serif;\n    margin: 0 0 15px;\n    padding: 0;\n    font-size: 30px !important;\n}\n\n.module-header {\n    font-family: 'Poppins', sans-serif;\n    margin: 0 0 50px;\n    text-align: center;\n}\n\n.module-line {\n    background: #666;\n    width: 55px;\n    height: 1px;\n    margin: 30px auto;\n}\n\n/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 600px) {\n    .column {\n        width: 100%;\n    }\n}\n\n//   /* If you want the content centered horizontally and vertically */\n//   .centered {\n//     position: absolute;\n//     top: 50%;\n//     left: 50%;\n//     transform: translate(-50%, -50%);\n//     text-align: center;\n//   }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
